export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '企业名称',
    dataIndex: 'name',
  },
  {
    title: '法人姓名',
    dataIndex: 'oper_name',
  },
  {
    title: '纳税人识别号',
    dataIndex: 'credit_code',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'name',
    lable: '企业名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'credit_code',
    lable: '纳税人识别号',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'qichacha_econ_kind',
    lable: '企业类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },

  {
    name: 'qichacha_status',
    lable: '登记状态',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },

  {
    name: 'qichacha_regist_capi',
    lable: '注册资本',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'qichacha_start_date',
    lable: '成立日期',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'oper_name',
    lable: '法定代表人名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'qichacha_address',
    lable: '注册地址',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'qichacha_scope',
    lable: '经营范围',
   lableCol: 2,
   wrapperCol: 21,
   offset: 0,
   span: 24,
  },
];